export default __webpack_public_path__ + "static/media/cultural-differences.7c448c23.svg";